//v1.0.1
window.feednami = {}
feednami.load = function(options,callback){
  var apiRoot = 'https://api.feednami.com/api/v1'
  var feedUrl = options
  if(typeof options == 'object'){
    feedUrl = options.url
  }
  var qs = 'url='+feedUrl
  if(options.format){
    qs += '&include_xml_document&format='+options.format
  }
  if(options.includeXml){
    qs += '&include_xml_document'
  }
  var url = apiRoot+'/feeds/load?'+qs
  if(window.XDomainRequest){
    var script = document.createElement('script')
    var callbackName = 'jsonp_callback_' 
    + new Date().getTime() + '_'
    + Math.round(1000000 * Math.random());
    url += '&jsonp_callback='+callbackName
    window[callbackName] = function(data) {
      callback(data);
      document.body.removeChild(script);
      window[callbackName] = null
      try{
        delete window[callbackName];
      }
      catch(e){
        
      }
    };
    script.src = url
    document.body.appendChild(script)
  }
  else{
    var req = new XMLHttpRequest()
    req.onreadystatechange = function(){
      if(req.readyState == 4){
        callback(JSON.parse(req.responseText))
      }
    }
    req.open('GET',url)
    req.send()
  }
}
feednami.loadGoogleFormat = function(feedUrl,callback){
  return feednami.load({
    url: feedUrl,
    format: 'google',
    includeXml: true
  },callback)
}

/*
 * EU custom script using the feedToJson extension
 */
$(document).ready(function() {
	
	
	var blog_feed = $('.blog-feed');
	
	// Check to make sure the .blog-feed element exists	
	if(blog_feed.length > 0){
		
		// If it does we are going to loop through all of them
		// We are doing this so we can have more than one RSS feed on a page
		$.each(blog_feed, function(){
			var url = $(this).data('url');
			
			// Generate the feed element
			generateBlogFeedElement(url, $(this));
		});
	}	
});


/** 
* Generate the blog feed element. 
* Print the blog RSS feed to the individual element
* 
* @param url String - Feed URL
* @param element Object - the HTML element to accept the blog feed item
*/
function generateBlogFeedElement(url, element){

	var num;
	var summary = false;
	
	if (element.attr('data-num')) {
		num = $('.blog-feed').data('num');
	} else {
		num = 4;
	}
	
	if (element.attr('data-summary')) {
		summary = true;
	}
	
	var hideSummary = element.data('hidesummary');
	
	feednami.load(url,function(result) {
					
		if (result.error !== null) {
			
			console.log(result.error);
			
		} else {
			
			var entries = result.feed.entries
			
			//console.log(entries);
			
			var html = '<ul class="article-list no-thumbs" data-url="' + url + '">';
				
			for (var i = 0; i < entries.length && i < num; i++) {
				
				var entry = entries[i];
				var body;
				
				// If the summary is set to be hidden then we are not going to set the body
				// but if the summary is not set to be hidden then we will set the body.
				if(hideSummary == false){
					
					if (summary) {
					
						body = entry.summary;
					
					} else {
						
						body = entry.description;
					
					}
				
				}else{
				
					body = "";
				
				}
				
				html += '<li><article>';
				html += '<a href="' + entry.link + '"><h1 class="headline">' + entry.title + '</h1></a>';
				
				// Hide the entry body when it is null or empty
				if(body !== null || body === ""){
					html += '<div class="summary">' + body + '<p></div>';
				}
				
				html += '</article></li>';
				
			}
			
			html += '</ul>';
			
			element.html(html);
		}
	});
}